const clone = (value) => {
  if (Array.isArray(value)) return value.map(clone);
  if (value && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, clone(item)]));
  }
  return value;
};

function normalizeTriggerUsers(users = []) {
  return (Array.isArray(users) ? users : [])
    .filter((user) => user?.id != null)
    .map((user) => ({
      id: user.id,
      username: user.username ?? user.name,
    }));
}

function normalizeTriggerStakeholders(stakeholders) {
  if (stakeholders === 'end_customer') return 'end_customer';
  return (Array.isArray(stakeholders) ? stakeholders : []).map((profile) => ({
    ...profile,
    users: normalizeTriggerUsers(profile?.users),
  }));
}

function normalizeTriggers(triggers = []) {
  return (Array.isArray(triggers) ? triggers : []).map((trigger) => ({
    ...trigger,
    users: normalizeTriggerUsers(trigger?.users),
    stakeholders: normalizeTriggerStakeholders(trigger?.stakeholders),
  }));
}

export function buildStatusPayload(status = {}, context = {}) {
  const payload = clone(status);
  payload.campaign_id = payload.campaign_id ?? context.campaignId ?? '';
  payload.leads_form_id = payload.leads_form_id ?? context.leadFormId ?? '';
  payload.substatuses = Array.isArray(payload.substatuses)
    ? payload.substatuses.map((substatus, index) => ({
        ...substatus,
        triggers: normalizeTriggers(substatus?.triggers),
        sub_status_id:
          substatus?.sub_status_id ||
          `${payload.status_name ?? 'status'}_${context.timestamp ?? Date.now()}_${index}`,
      }))
    : [];
  payload.triggers = normalizeTriggers(payload.triggers);
  return payload;
}

/** Alias for save flows that expect the legacy trigger normalization name. */
export function buildStatusWorkflowPayload(status = {}, context = {}) {
  return buildStatusPayload(status, context);
}

export function buildStatusOrderPayload(statuses = []) {
  return (Array.isArray(statuses) ? statuses : []).map((status, index) => ({
    status_id: status?.status_id ?? status?.id ?? status?.statusId,
    sort_num: index + 1,
  }));
}

export function normalizeAssignedUsers(users = []) {
  return normalizeTriggerUsers(users);
}
